export default __webpack_public_path__ + "static/media/traininglanding.22828aa9.PNG";